// extracted by mini-css-extract-plugin
export default {"root":"lincd_capacitor_SigninWithGoogleButton_root","icon":"lincd_capacitor_SigninWithGoogleButton_icon"};